export async function contactUsPublic(apiInstance, data) {
  try {
    const response = await apiInstance.post(`/Public/contactus`, data);
    return response.data;
  } catch (err) {
    const message = err.response?.data?.message || "An error occurred";
    const error = new Error(message);
    error.response = err.response;
    throw error;
  }
}

export async function fetchFilterResults(apiInstance, data) {
  try {
    const response = await apiInstance.get(`/Public/leaderboard${data}`);
    return response.data;
  } catch (err) {
    const message = err.response?.data?.message || "Error fetching results";
    const error = new Error(message);
    error.response = err.response;
    throw error;
  }
}

export async function fetchPublicEvents(apiInstance) {
  try {
    const response = await apiInstance.get(`/Public/search-event`);
    return response.data;
  } catch (err) {
    const message = err.response?.data?.message || "Error fetching results";
    const error = new Error(message);
    error.response = err.response;
    throw error;
  }
}

//service for search event public
export async function searchEventPublic(apiInstance, query) {
  try {
    const response = await apiInstance.get(`/Public/search-event?q=${query}`);
    return response.data;
  } catch (err) {
    const message =
      err.response?.data?.message ||
      "An error occurred while searching for events";
    const error = new Error(message);
    error.response = err.response;
    throw error;
  }
}

// SERVICES FOR RESET  Password
export async function sendResetPasswordEmail(apiInstance, email) {
  try {
    const response = await apiInstance.post(
      `/User/send-resetpassword-email/${email}`,
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}

export async function verifyResetPassword(apiInstance, accessCode, email) {
  try {
    await apiInstance.get(`/User/verify-reset-password/${accessCode}/${email}`);
  } catch (err) {
    const message = err.response?.data?.message || "Verification failed.";
    const error = new Error(message);
    error.response = err.response;
    throw error;
  }
}

export async function resetPassword(apiInstance, accessCode, email, password) {
  try {
    const response = await apiInstance.put(`/User/reset-password`, {
      accessCode,
      email,
      password,
    });
    return response.data;
  } catch (err) {
    const message =
      err.response?.data?.message ||
      "An error occurred while resetting the password";
    const error = new Error(message);
    error.response = err.response;
    throw error;
  }
}
